import { convertToPST } from "../../../Helper/FormatDatetimes";
import { useTranslation } from "react-i18next";

const MaintenanceReportLite = ({ report, close }) => {
  const { t } = useTranslation();
  return (
    <div className="page-mask-2 page-mask-animation">
      <div className="edit-modal">
        <h2 className="global-h2">{t("page-headers.maintenance-report")}</h2>
        <div className="form-block">
          <label className="input-label">
            {t("forms.type.maintenance-report.labels.created-by")}:
          </label>
          <label className="input-label">
            {report.user.first_name} {report.user.last_name}
          </label>
        </div>
        <div className="form-block">
          <label className="input-label">
            {t("forms.type.maintenance-report.labels.created-at")}
          </label>
          <label className="input-label">
            {convertToPST(report.created_at)}
          </label>
        </div>
        <div className="form-block">
          <label className="input-label">
            {t("forms.type.maintenance-report.labels.due-date")}
          </label>
          <label className="input-label">
            {report.expected_date ? convertToPST(report.expected_date) : "N/A"}
          </label>
        </div>
        <div className="form-block">
          <label className="input-label">
            {t("forms.type.vehicle.input-headers.notes")}
          </label>
          <label className="input-label">{report.notes}</label>
        </div>
        <div className="full-cont">
          <button className="cancel-btn" onClick={close}>
            {t("buttons.close")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceReportLite;